import jwtDecode from "jwt-decode";
import { TokenObject } from "../sharedTypes/auth-types";
import { StatusType } from "./models";

/**
 * check current time against provided session time
 * @param expirationTime
 * @returns true if current time < session time, false otherwise
 */
export function isSessionTokenValid(expirationTime: number) {
  return Date.now() < Number(expirationTime * 1000);
}

// Here, we decode the encoded string and return the object
export function convertTokenStringToObject(accessTokenString: string) {
  let tokenStringToObject: TokenObject;
  try {
    tokenStringToObject = jwtDecode(accessTokenString);
    return tokenStringToObject;
  } catch (error) {
    return null;
  }
}

export function formatDateToYYYYMMDD(date: Date | string): string {
  // If date is a string, convert it to a Date object
  if (typeof date === "string") {
    date = new Date(date);
  }

  if (date instanceof Date && !isNaN(date.getTime())) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  } else {
    // If date is invalid, return an empty string
    return "";
  }
}

export const debounce = <T extends (...args: any[]) => void>(
  func: T,
  wait: number
): ((...args: Parameters<T>) => void) => {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  return (...args: Parameters<T>) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
};

export const addLinkDownload = (title: string, base64Data: string) => {
  const csvData = atob(base64Data);

  const blob = new Blob([csvData], { type: "text/csv" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = title;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};

export const getStatusStyles = (status: StatusType) => {
  switch (status) {
    case "SUCCESS":
    case "CREDIT":
      return "tw-text-green-800 tw-bg-green-100";
    case "FAILURE":
    case "DEBIT":
      return "tw-text-red-800 tw-bg-red-100";
    default:
      return "tw-text-yellow-900 tw-bg-yellow-100";
  }
};
